import { Check, CircleExclamation } from '@gravity-ui/icons';
import { Icon } from '@gravity-ui/uikit';

import { AGREEMENT_FAILURE, AGREEMENT_SUCCESS } from '../../constants';

import styles from './styles.module.scss';

export interface ClientAgreementProps {
	value?: boolean;
}

export const ClientAgreement = ({ value }: ClientAgreementProps) => {
	if (value) {
		return (
			<div className={`${styles.agreement} ${styles.success}`}>
				<Icon data={Check} size={12} />
				{AGREEMENT_SUCCESS}
			</div>
		);
	}

	return (
		<div className={`${styles.agreement} ${styles.failure}`}>
			<Icon data={CircleExclamation} size={12} /> {AGREEMENT_FAILURE}
		</div>
	);
};
